module.exports = __webpack_public_path__ + "static/img/logo.8c1870f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 7Otq
// module chunks = 11